module.exports = __webpack_public_path__ + "img/icon_whatsapp-pink.26a19e91.svg";